import api from '@/api'
import utils from '@/store/utils'

const initialState = () => ({
    azienda: null,
    agricoltori: [],
    tecnici: [],
    convenzioni: [],
    unitaMobili: [],
    lastIndirizzo: null,
    categorieProdotti: [],
    prodottiDismessi: [],
    prodottiShop: [],
    macchine: [],
    loading: {
        azienda: false,
        agricoltori: false,
        tecnici: false,
        convenzioni: false,
        unitaMobili: false,
        categorieProdotti: false,
        prodottiDismessi: false,
        prodottiShop: false,
        macchine: false
    }
})

export default {
    state: initialState(),
    mutations: {
        SET_AZIENDA: utils.set('azienda'),
        SET_AGRICOLTORI: utils.set('agricoltori'),
        SET_TECNICI: utils.set('tecnici'),
        SET_CONVENZIONI: utils.set('convenzioni'),
        SET_UNITA_MOBILI: utils.set('unitaMobili'),
        SET_LAST_INDIRIZZO: utils.set('lastIndirizzo'),
        SET_CATEGORIE_PRODOTTI: utils.set('categorieProdotti'),
        SET_PRODOTTI_DISMESSI: utils.set('prodottiDismessi'),
        SET_MACCHINE: utils.set('macchine'),
        ADD_PRODOTTI_SHOP: (state, { categoria, prodotti }) => {
            state.prodottiShop.push({ categoria, prodotti })
        },
        RESET: (state) => {
            const initial = initialState()
            Object.keys(initial).forEach(key => {
                state[key] = initial[key]
            })
        }
    },
    actions: {
        loadAzienda: utils.load('azienda', 'SET_AZIENDA', api.azienda.get),
        loadAgricoltori: utils.load('agricoltori', 'SET_AGRICOLTORI', api.agricoltori.getPartial),
        loadTecnici: utils.load('tecnici', 'SET_TECNICI', api.tecnici.getPartial, (tecnico) => ({
            ...tecnico,
            nome_cognome: `${tecnico.nome} ${tecnico.cognome}`
        })),
        loadConvenzioni: utils.load('convenzioni', 'SET_CONVENZIONI', api.convenzioni.getPartial),
        loadUnitaMobili: utils.load('unitaMobili', 'SET_UNITA_MOBILI', api.unitaMobili.getPartial),
        loadCategorieProdotti: utils.load('categorieProdotti', 'SET_CATEGORIE_PRODOTTI', api.magazzino.getCategories),
        loadProdottiDismessi: utils.load('prodottiDismessi', 'SET_PRODOTTI_DISMESSI', api.magazzino.getInternalDismessi),
        loadMacchine: utils.load('macchine', 'SET_MACCHINE', api.macchine.get),
        loadProdottiShop: async ({ commit, state, getters }, categoria) => {
            if (!getters.getProdottiShopByCategory(categoria)) {
                state.loading.prodottiShop = true
                try {
                    let response = await api.magazzino.getExternalByCategory(categoria)
                    let prodotti = response.data.map(prodotto => {
                        prodotto.price = Number(prodotto.price)
                        return prodotto
                    })
                    commit('ADD_PRODOTTI_SHOP', { categoria, prodotti })
                } finally {
                    state.loading.prodottiShop = false
                }
            }
        },
        reset: ({ commit }) => {
            commit('RESET')
        }
    },
    getters: {
        getAgricoltoreById: state => id => state.agricoltori.find(agricoltore => agricoltore.id === id),
        getTecnicoById: state => id => state.tecnici.find(tecnico => tecnico.id === id),
        getProdottiShopByCategory: state => categoria => {
            let prodottoShop = state.prodottiShop.find(prodottoShop => prodottoShop.categoria === categoria)
            return prodottoShop && prodottoShop.prodotti
        }
        // getMacchine: state => id => state.macchine.find(macchine => macchine.id === id)
    }
}
